import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "components/ui/Input";
import { useGenerateJournalBookReport } from "http-hooks/salebill/useSalebill";
import { getDocumentUrls, getDocumentViewerRoute } from "utils/documentUrlHelper";

const JournalBook = () => {
  const navigate = useNavigate();
  const { mutateAsync: generateReport, isPending: isGenerating } = useGenerateJournalBookReport();
  
  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const reportData = {
        fromdate: formData.fromDate,
        todate: formData.toDate,
      };

      const data = await generateReport(reportData);
      
      const { htmlUrl, pdfUrl } = getDocumentUrls(data);
      
      const route = getDocumentViewerRoute("journal-book", {
        htmlUrl,
        pdfUrl,
        documentNumber: `JB-${new Date().getTime()}`,
        documentType: "Journal Book",
      });
      
      navigate(route);
    } catch (error) {
      console.error("Error generating journal book report:", error);
    }
  };

  const isFormValid = () => {
    return formData.fromDate !== "" && formData.toDate !== "";
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">Journal Book Report Generator</h1>
          <p className="mt-2 text-sm text-gray-700">
            Generate journal book report for a date range
          </p>
        </div>
      </div>

      <div className="mt-8">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
            <div className="px-4 py-6 sm:p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {/* From Date */}
                <div className="col-span-1 md:col-span-2 lg:col-span-1">
                  <Input
                    label="From Date"
                    type="date"
                    value={formData.fromDate}
                    onChange={(e) => setFormData({ ...formData, fromDate: e.target.value })}
                    fys={true}
                    withinFY={true}
                    required
                  />
                </div>

                {/* To Date */}
                <div className="col-span-1 md:col-span-2 lg:col-span-1">
                  <Input
                    label="To Date"
                    type="date"
                    value={formData.toDate}
                    onChange={(e) => setFormData({ ...formData, toDate: e.target.value })}
                    fye={true}
                    withinFY={true}
                    required
                  />
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
              <button
                type="submit"
                disabled={!isFormValid() || isGenerating}
                className={`rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${
                  isFormValid() && !isGenerating && "bg-indigo-600 hover:bg-indigo-500"
                } ${(!isFormValid() || isGenerating) && "bg-gray-400 cursor-not-allowed"}`}
              >
                {isGenerating ? "Generating..." : "Generate Report"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default JournalBook;

